import { DialogComponent } from '@theme/dialog';

/**
 * A custom element that manages a custom popup drawer.
 *
 * @extends {DialogComponent}
 */
class FindOutWhyPopupComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  open() {
    this.showDialog();
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('find-out-why-popup-component')) {
  customElements.define('find-out-why-popup-component', FindOutWhyPopupComponent);
}